// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-datatable-thead th:nth-child(2) {
    width: 60% !important;
  }


  .custom-hover-button:hover {
    background-color:rgb(222, 222, 222) !important;
    border-color: rgb(204, 204, 204) !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/features/engagement/viewall-engagement/engagement.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;EACvB;;;EAGA;IACE,8CAA8C;IAC9C,2CAA2C;EAC7C","sourcesContent":[".p-datatable-thead th:nth-child(2) {\r\n    width: 60% !important;\r\n  }\r\n\r\n\r\n  .custom-hover-button:hover {\r\n    background-color:rgb(222, 222, 222) !important;\r\n    border-color: rgb(204, 204, 204) !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
